import { useTheme } from '@mui/material/styles'
import { useRrhh } from '../../../../shared/context/rrhhContext'
import DropFiles from '../../../../shared/components/DropFiles'
import { Box, Button, LinearProgress, Typography } from '@mui/material'
import { useEffect } from 'react'
import { CloudUpload as CloudUploadIcon, Download as DownloadIcon } from '@mui/icons-material'
export default function ListMasiveComponent() {

    const theme = useTheme()
    const { loadMasiveRrhh, dataMasive, responseMasive, loadingMasive, processMasiveRrhh, loadingUploadMasive, setDataMasive, setResponseMasive } = useRrhh()

    useEffect(() => {
        return () => {
            setDataMasive(null)
            setResponseMasive(null) 
        }
    }, [])

    return (
        <Box sx={{padding: '20px'}}>
            <DropFiles onChange={(files) => loadMasiveRrhh(files)} />


            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                marginTop: 2,
                marginBottom: 3,
                padding: 2,
                backgroundColor: theme.palette.background.paper,
                borderRadius: 1,
                boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
                        ¿Primera vez cargando personal?
                    </Typography>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                        Descarga la plantilla Excel para cargar tu personal masivamente
                    </Typography>
                </Box>
                <Button
                    variant="outlined"
                    href="https://operacionessistema.s3.us-west-2.amazonaws.com/plantillas/RRHH.xlsx"
                    target="_blank"
                    endIcon={<DownloadIcon />}
                    sx={{
                        minWidth: '140px',
                        '&:hover': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText
                        }
                    }}
                >
                    Descargar Plantilla
                </Button>
            </Box>

                
            <Box sx={{marginTop: '20px'}} >
                <Button disabled={!dataMasive || loadingMasive} variant="contained" color="primary" onClick={processMasiveRrhh} startIcon={<CloudUploadIcon />}   
                > 
                {loadingUploadMasive ? 'Cargando...' : 'Procesar y cargar (' + (dataMasive?.length || 0) + ' personal)'}
               </Button>
            </Box>

            {loadingMasive && (
                <Box sx={{marginTop: '20px'}}> 
                    <LinearProgress />
                </Box>
            )}

            {responseMasive && (
                <Box sx={{ marginTop: '30px', border: `1px solid ${theme.palette.divider}`, borderRadius: '8px', padding: '20px' }}>
                    <Typography variant="h6" gutterBottom>
                        Resultados de la carga
                    </Typography>
                    
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
                        <Box sx={{ 
                            padding: '15px', 
                            borderRadius: '8px', 
                            backgroundColor: theme.palette.success.light,
                            minWidth: '200px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            transition: 'transform 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-5px)'
                            }
                        }}>
                            <Typography variant="subtitle1">Personal creado</Typography>
                            <Typography variant="h4">{responseMasive?.users_created?.length}</Typography>
                        </Box>
                        
                        <Box sx={{ 
                            padding: '15px', 
                            borderRadius: '8px', 
                            backgroundColor: theme.palette.error.light,
                            minWidth: '200px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            transition: 'transform 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-5px)'
                            }
                        }}>
                            <Typography variant="subtitle1">Personal no creado</Typography>
                            <Typography variant="h4">{responseMasive?.users_not_created?.length}</Typography>
                        </Box>
                    </Box>
                    
                    {responseMasive?.users_not_created?.length > 0 && (
                        <Box sx={{ marginTop: '20px' }}>
                            <Typography variant="subtitle1" color="error" gutterBottom>
                                Detalles de personal no creado
                            </Typography>
                            <Box sx={{ 
                                maxHeight: '200px', 
                                overflowY: 'auto',
                                border: `1px solid ${theme.palette.divider}`,
                                borderRadius: '4px'
                            }}>
                                {responseMasive.users_not_created.map((item, index) => (
                                    <Box key={index} sx={{ 
                                        padding: '10px', 
                                        borderBottom: index < responseMasive.users_not_created.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                                        backgroundColor: index % 2 === 0 ? theme.palette.action.hover : 'transparent'
                                    }}>
                                        <Typography variant="body2" fontWeight="bold">
                                            {item.fullName || 'Sin nombre'} ({item.num_document || 'Sin documento'})
                                        </Typography>
                                        <Typography variant="body2" color="error">
                                            Error: {item.message}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    )
} 